import normalizeColors from "../libs/normalizeColors";
import ProgressBar from "../ProgressBar/ProgressBar.onea";
import ProgressBarStep from "../ProgressBar/ProgressBarStep.onea";
import SliderInput from "../SliderWithControls/SliderInput.onea";
import { fromJS } from 'immutable';
export default fromJS({
  name: 'onea',
  globals: {
    colors: normalizeColors({
      primary: '#00b2d5',
      whiteDark: '#CBD3DA'
    })
  },
  ProgressBar: ProgressBar,
  ProgressBarStep: ProgressBarStep,
  SliderInput: SliderInput
});